import moment from 'moment'
import 'moment/locale/fr'
import 'moment/locale/de'
import 'moment/locale/it'
import 'moment/locale/es'
import 'moment/locale/pt'
import 'moment/locale/ru'
import 'moment/locale/en-gb'

import { getLocaleFromLanguageCode } from './localeUtils'

export const setMomentLocale = languageCode => {
  const locale = getLocaleFromLanguageCode(languageCode)
  moment.locale(locale)
}

export const getMomentWithLocale = (date, languageCode) => {
  const locale = getLocaleFromLanguageCode(languageCode)
  const dateMoment = date ? date.clone() : date

  if (dateMoment && locale && locale != dateMoment.locale()) {
    dateMoment.locale(locale)
  }
  return dateMoment
}
